module.exports = __webpack_public_path__ + "img/TraumVI.17c0841d.jpg";